import { i18n } from '@/locale'
import store from '@/store'
import moment from 'moment'
import { timeFormats } from '@/config'
import { getDayOfWeek } from '@/lib/helpers/Time'


function getTimeFormat () {
  const typeFormat = store.state.me.settings.webappUser.timeFormat
  return (typeFormat === timeFormats['H_24']) ? 'HH:mm' : 'hh:mm A'
}

function formatHour (hour) {
  return `${ moment.utc(hour).format(getTimeFormat()) }`
}

function formatRange (range) {
  return `${ formatHour(range.startHour) } - ${ formatHour(range.endHour) }`
}
function formatTime (duration) {
  let minutes = Math.floor((duration / (1000 * 60)) % 60)
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24)

  hours = (hours < 10) ? '0' + hours : hours
  minutes = (minutes < 10) ? '0' + minutes : minutes

  return hours + ':' + minutes
}

function colonHourToMs (colonHour) {
  return colonHour ? parseInt(colonHour.split(':')[0]) * 60 * 60 * 1000 + parseInt(colonHour.split(':')[1]) * 60 * 1000 : null
}

function formatDuration ({ ms, extended }) {
  const millisecond = ((((ms % 31536000000) % 86400000) % 3600000) % 60000) % 0
  if (ms > 0) {
    const years = Math.floor(ms / 31536000000)
    const days = Math.floor((ms % 31536000000) / 86400000)
    const hours = Math.floor(((ms % 31536000000) % 86400000) / 3600000)
    const minutes = Math.floor((((ms % 31536000000) % 86400000) % 3600000) / 60000)
    const seconds = Math.floor(((((ms % 31536000000) % 86400000) % 3600000) % 60000) / 60000)
    let y = years ? ` ${ years }${ i18n.t('measurement_unit.year') }` : ''
    let d = days ? ` ${ days }${ i18n.t('measurement_unit.day') }` : ''
    let h = hours ? ` ${ hours }${ i18n.t('measurement_unit.h') }` : ''
    let m = minutes ? ` ${ minutes }${ i18n.t('measurement_unit.min') }` : ''
    if (extended) {
      y = years ? ` ${ i18n.tc('measurement_unit.year_quantified', years) }` : ''
      d = days ? ` ${ i18n.tc('measurement_unit.day_quantified', days) }` : ''
      h = hours ? ` ${ i18n.tc('measurement_unit.hour_quantified', hours) }` : ''
      m = minutes ? ` ${ i18n.tc('measurement_unit.minute_quantified', minutes) }` : ''
    } else {
    }
    const s = seconds ? `${ seconds }${ i18n.t('measurement_unit.s') }` : ''
    const msds = millisecond ? `${ millisecond }${ i18n.t('measurement_unit.ms') }` : ''
    const str = (y + d + h + m + s + msds).trim()
    return str
  }
}

function getDayOfWeekTransalation (day) {
  const translationDays = [
    i18n.t('activities.dow.sunday'),
    i18n.t('activities.dow.monday'),
    i18n.t('activities.dow.tuesday'),
    i18n.t('activities.dow.wednesday'),
    i18n.t('activities.dow.thursday'),
    i18n.t('activities.dow.friday'),
    i18n.t('activities.dow.saturday'),
  ]
  return translationDays[day]
}

function getDatesOfThisWeek (firstDayOfWeek) {
  moment.locale(i18n.locale)
  const daysOfOneWeek = 7
  const defaultSundayDow = 0
  const defaultMondayDow = 1
  const firstDayOfWeekNumber = getDayOfWeek(firstDayOfWeek)
  const dowDifferenceThanFirstDate = firstDayOfWeekNumber === defaultSundayDow || firstDayOfWeekNumber === defaultMondayDow ? firstDayOfWeekNumber + daysOfOneWeek - daysOfOneWeek : firstDayOfWeekNumber - daysOfOneWeek
  const datesOfCurrentWeek = {}
  const today = moment()
  const currentDayOfWeek = today.day()
  for (let dayOfWeek = 0; dayOfWeek < daysOfOneWeek; dayOfWeek++) {
    const diffDays = (dayOfWeek + dowDifferenceThanFirstDate) - currentDayOfWeek
    const calculatedDayOfWeek = moment(today).add(diffDays, 'days')
    datesOfCurrentWeek[calculatedDayOfWeek.day()] = calculatedDayOfWeek.format('YYYY-MM-DD')
  }
  return datesOfCurrentWeek
}

function getDaysOfMonthOnThisWeek (firstDayOfWeek) {
  moment.locale(i18n.locale)
  const datesOfThisWeek = getDatesOfThisWeek(firstDayOfWeek)
  const daysOfCurrentWeek = {}
  for (const [dow, date] of Object.entries(datesOfThisWeek)) {
    daysOfCurrentWeek[dow] = moment(date).date()
  }
  return daysOfCurrentWeek
}

export {
  formatHour,
  formatRange,
  formatTime,
  colonHourToMs,
  formatDuration,
  getTimeFormat,
  getDayOfWeekTransalation,
  getDatesOfThisWeek,
  getDaysOfMonthOnThisWeek,
}
